import React from 'react';
import { styled, useTheme } from '@mui/material/styles';
import { Drawer, Divider, IconButton } from '@mui/material';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Filters from '../Filters/Filters';
import useGlobalState, { sidebarState } from '../../globalState';


const DrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  padding: theme.spacing(0, 1),
  // necessary for content to be below app bar
  ...theme.mixins.toolbar,
  justifyContent: 'flex-end',
}));

const Sidebar = () => {
  const [open, setSidebarState] = useGlobalState(sidebarState);
  const drawerWidth = 240;
  const theme = useTheme();
  const handleDrawerClose = () => {
    console.log('closing')
    setSidebarState(false);
  };

  return (
    // <Drawer
    //   sx={{
    //     width: drawerWidth,
    //     flexShrink: 0,
    //     '& .MuiDrawer-paper': {
    //       width: drawerWidth,
    //       boxSizing: 'border-box',
    //     },
    //   }}
    //   variant='permanent'
    //   anchor='left'
    // >
    //   <Toolbar />
    //   <Divider />
    //   <Filters />
    // </Drawer>


    <Drawer
      sx={{
        width: drawerWidth,
        flexShrink: 0,
        '& .MuiDrawer-paper': {
          width: drawerWidth,
          boxSizing: 'border-box',
        },
      }}
      variant='persistent'
      anchor='left'
      open={open}
    >
      <DrawerHeader>
        <IconButton onClick={handleDrawerClose}>
          {theme.direction === 'ltr' ? <ChevronLeftIcon /> : <ChevronRightIcon />}
        </IconButton>
      </DrawerHeader>
      <Divider />
      <Filters />
    </Drawer>
  );
}

export default Sidebar;